/** @format */

import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AddToCartButtonService {
  private readonly openCustomPanelSubject = new Subject<boolean>();
  private readonly openNotifyMePanelSubject = new Subject<boolean>();
  private readonly addToCartClickSubject = new Subject<void>();

  openCustomPanel$ = this.openCustomPanelSubject.asObservable();
  openNotifyMePanel$ = this.openNotifyMePanelSubject.asObservable();
  addToCartClick$ = this.addToCartClickSubject.asObservable();

  emitOpenCustomPanel(value: boolean) {
    this.openCustomPanelSubject.next(value);
  }

  emitOpenNotifyMePanel(value: boolean) {
    this.openNotifyMePanelSubject.next(value);
  }

  emitAddToCartClick() {
    this.addToCartClickSubject.next();
  }
}
